export default "__VITE_ASSET__laL3Dc4o__"